module.exports = __webpack_public_path__ + "static/assets/5c35f75af2be0e85c8ed77d53b36dcb8.svg";